import * as yup from 'yup';
import {
  ContactDataSchema,
  HealthInsuranceSchema,
  IContactData,
  IHealthInsurance,
  IHealthInsuranceInput,
  IUpdateContactData,
  UpdateContactDataSchema,
} from '../../../common';
import {
  IPersonalData,
  IUpdatePersonalData,
  PersonalDataSchema,
  UpdatePersonalDataSchema,
} from './IPersonalData';

export const EmployeeBaseDataSchema = yup.object({
  personalData: PersonalDataSchema.optional().default(undefined),
  contactData: ContactDataSchema.optional().default(undefined),
  healthInsurance: HealthInsuranceSchema.optional().default(undefined),
  remark: yup.string().notRequired(),
});

export interface IEmployeeBaseData {
  personalData: IPersonalData;
  contactData: IContactData;
  healthInsurance?: IHealthInsurance;
  remark?: string;
}

export const CreateEmployeeBaseDataSchema = yup.object({
  personalData: PersonalDataSchema.optional().default(undefined),
  contactData: ContactDataSchema.optional().default(undefined),
  healthInsurance: HealthInsuranceSchema.optional().default(undefined),
  remark: yup.string().notRequired(),
});

export interface ICreateEmployeeBaseData {
  personalData: IPersonalData;
  contactData: IContactData;
  healthInsurance?: IHealthInsuranceInput;
  remark?: string;
}

export const UpdateEmployeeBaseDataSchema = yup.object({
  personalData: UpdatePersonalDataSchema.optional().default(undefined),
  contactData: UpdateContactDataSchema.optional().default(undefined),
  healthInsurance: HealthInsuranceSchema.optional().default(undefined),
  remark: yup.string().notRequired(),
});

export interface IUpdateEmployeeBaseData {
  personalData?: IUpdatePersonalData;
  contactData?: IUpdateContactData;
  healthInsurance?: IHealthInsuranceInput;
  remark?: string;
}
